export default __webpack_public_path__ + "static/hero-img-678946c1c5dfdb09ae203f21243300e5.png";